import { browserSupportsWebAuthn } from '@simplewebauthn/browser';
import { Redirect } from '@mews-commander/ui';
import { FeatureFlag } from '@mews-commander/enums';
import { useFeatureFlag } from '@mews/framework';
import { GeneralPasswordStrength } from '@mews-commander/data-access';
import { getStrictCurrentEnterpriseId, isLoggedInSession, useCurrentSession } from '@mews-commander/core';
import { usePasswordStrength, useSuggestPasskeySetup } from '../usePublicStore';

export const SignInRedirect = ({ redirect: redirectTo, children }: React.PropsWithChildren<{ redirect?: string }>) => {
    const currentSession = useCurrentSession();
    const passwordStrength = usePasswordStrength();
    const passwordScannerEnabled = useFeatureFlag(FeatureFlag.passwordScannerEnabled);

    const createPasskeyPageEnabled = useShowCreatePasskeyPage();
    const suggestPasskeySetup = useSuggestPasskeySetup();

    if (!isLoggedInSession(currentSession)) {
        return <>{children}</>;
    }

    if (redirectTo?.startsWith('/')) {
        return <Redirect to={redirectTo} />;
    }

    if (passwordScannerEnabled && passwordStrength === GeneralPasswordStrength.Weak) {
        return <Redirect to="/Home/WeakPassword" />;
    }

    if (createPasskeyPageEnabled && suggestPasskeySetup) {
        return <Redirect to="/Home/CreatePasskey" />;
    }

    return (
        <Redirect
            to="/$currentEnterpriseId/Dashboard/Index"
            params={{
                currentEnterpriseId: getStrictCurrentEnterpriseId(),
            }}
        />
    );
};

const useShowCreatePasskeyPage = () => {
    const passkeysKillSwitchEnabled = useFeatureFlag(FeatureFlag.passkeySignInUiEnabled);
    const passkeysEnabled = useFeatureFlag(FeatureFlag.passkeySignInEnabled);
    const hasPasskeySupport = browserSupportsWebAuthn();

    return passkeysEnabled && passkeysKillSwitchEnabled && hasPasskeySupport;
};
